import useSubformBuildingInfoStyles from './UseSubformBuildingInfoStyles';
import useSubformBuildingLimitsStyles from './UseSubformBuildingLimitsStyles';
import useSubformCoverageLimitsPersonalStyles from './UseSubformCoverageLimitsPersonalStyles';
import useSubformDwellingInfoStyles from './UseSubformDwellingInfoStyles';
import useSubformInsuredInfoContactStyles from './UseSubformInsuredInfoContactStyles';
import useSubformInsuredInfoMailingAddressStyles from './UseSubformInsuredInfoMailingAddressStyles';
import useSubformMortgageesComparisonStyles from './UseSubformMortgageesComparisonStyles';
import useSubformMortgageeStyles from './UseSubformMortgageeStyles';
import useSubformPerilsDeductiblesStyles from './UseSubformPerilsDeductiblesStyles';
import useSubformPropertyAddressStyles from './UseSubformPropertyAddressStyles';

export {
	useSubformBuildingInfoStyles,
	useSubformBuildingLimitsStyles,
	useSubformCoverageLimitsPersonalStyles,
	useSubformDwellingInfoStyles,
	useSubformInsuredInfoContactStyles,
	useSubformInsuredInfoMailingAddressStyles,
	useSubformMortgageesComparisonStyles,
	useSubformMortgageeStyles,
	useSubformPerilsDeductiblesStyles,
	useSubformPropertyAddressStyles,
};